"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var merchantStatementCompanyApi = _interopRequireWildcard(require("@/api/merchantStatementCompanyApi"));
var _EditCompanyDialog = _interopRequireDefault(require("./components/EditCompanyDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditCompanyDialog: _EditCompanyDialog.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        companyName: '',
        taxNo: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  methods: {
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      merchantStatementCompanyApi.getCompanyList(this.listPram).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handlerReset: function handlerReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        companyName: '',
        taxNo: ''
      };
      this.handerSearch();
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs.EditCompanyDialogRef.openInit(row);
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this2 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u8BE5\u516C\u53F8\"".concat(rowData.companyName, "\"\u5417\uFF1F"), '提示').then(function () {
        merchantStatementCompanyApi.deleteCompany(rowData.id).then(function () {
          _this2.$message.success('删除成功');
          var totalPage = Math.ceil((_this2.listData.total - 1) / _this2.listPram.limit);
          if (_this2.listPram.page > totalPage) {
            _this2.listPram.page = totalPage || 1;
          }
          _this2.handlerGetListData();
        });
      }).catch(function () {});
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    formatDateTime: function formatDateTime(val) {
      return val ? val.replace('T', ' ').substring(0, 19) : '-';
    }
  }
};